export const environment = { 
  production: false,
  apiUrl: "https://api-dev.consulteimed.com.br",
  // apiUrl: "https://api.consulteimed.com.br",
  
  // shortenerUrl: "https://link.consulteimed.com.br",
  shortenerUrl: "https://link-dev.consulteimed.com.br",
};